<template>
<div class="InteractTools">
</div>
</template>

<script>
export default {
    name: 'InteractTools',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.InteractTools {
}
</style>
